/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthSupportsRequest } from '../models/auth-supports-request';
import { authSupportsRequestAddComment } from '../fn/auth-supports-request/auth-supports-request-add-comment';
import { AuthSupportsRequestAddComment$Params } from '../fn/auth-supports-request/auth-supports-request-add-comment';
import { AuthSupportsRequestPagedList } from '../models/auth-supports-request-paged-list';
import { changeAuthSupportsRequestState } from '../fn/auth-supports-request/change-auth-supports-request-state';
import { ChangeAuthSupportsRequestState$Params } from '../fn/auth-supports-request/change-auth-supports-request-state';
import { createAuthSupportsRequest } from '../fn/auth-supports-request/create-auth-supports-request';
import { CreateAuthSupportsRequest$Params } from '../fn/auth-supports-request/create-auth-supports-request';
import { createSubscriptionAuthSupportsRequest } from '../fn/auth-supports-request/create-subscription-auth-supports-request';
import { CreateSubscriptionAuthSupportsRequest$Params } from '../fn/auth-supports-request/create-subscription-auth-supports-request';
import { deleteAuthSupportsRequest } from '../fn/auth-supports-request/delete-auth-supports-request';
import { DeleteAuthSupportsRequest$Params } from '../fn/auth-supports-request/delete-auth-supports-request';
import { deleteSubscriptionAuthSupportsRequest } from '../fn/auth-supports-request/delete-subscription-auth-supports-request';
import { DeleteSubscriptionAuthSupportsRequest$Params } from '../fn/auth-supports-request/delete-subscription-auth-supports-request';
import { downloadAuthSupportsRequestTemplateFile } from '../fn/auth-supports-request/download-auth-supports-request-template-file';
import { DownloadAuthSupportsRequestTemplateFile$Params } from '../fn/auth-supports-request/download-auth-supports-request-template-file';
import { FileDownloadResponse } from '../models/file-download-response';
import { generateAuthSupportsRequest } from '../fn/auth-supports-request/generate-auth-supports-request';
import { GenerateAuthSupportsRequest$Params } from '../fn/auth-supports-request/generate-auth-supports-request';
import { getAuthSupportsRequest } from '../fn/auth-supports-request/get-auth-supports-request';
import { GetAuthSupportsRequest$Params } from '../fn/auth-supports-request/get-auth-supports-request';
import { getSubscriptionAuthSupportsRequest } from '../fn/auth-supports-request/get-subscription-auth-supports-request';
import { GetSubscriptionAuthSupportsRequest$Params } from '../fn/auth-supports-request/get-subscription-auth-supports-request';
import { getSubscriptionsAuthSupportsRequestStats } from '../fn/subscriptions/get-subscriptions-auth-supports-request-stats';
import { GetSubscriptionsAuthSupportsRequestStats$Params } from '../fn/subscriptions/get-subscriptions-auth-supports-request-stats';
import { listAuthSupportsRequests } from '../fn/auth-supports-request/list-auth-supports-requests';
import { ListAuthSupportsRequests$Params } from '../fn/auth-supports-request/list-auth-supports-requests';
import { SubscriptionAuthSupportsRequestStats } from '../models/subscription-auth-supports-request-stats';
import { updateAuthSupportsRequest } from '../fn/auth-supports-request/update-auth-supports-request';
import { UpdateAuthSupportsRequest$Params } from '../fn/auth-supports-request/update-auth-supports-request';
import { updateSubscriptionAuthSupportsRequest } from '../fn/auth-supports-request/update-subscription-auth-supports-request';
import { UpdateSubscriptionAuthSupportsRequest$Params } from '../fn/auth-supports-request/update-subscription-auth-supports-request';
import { uploadAuthSupportsRequestFile } from '../fn/auth-supports-request/upload-auth-supports-request-file';
import { UploadAuthSupportsRequestFile$Params } from '../fn/auth-supports-request/upload-auth-supports-request-file';


/**
 * All about the sites operation
 */
@Injectable({ providedIn: 'root' })
export class AuthSupportsRequestService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSubscriptionsAuthSupportsRequestStats()` */
  static readonly GetSubscriptionsAuthSupportsRequestStatsPath = '/custom/subscriptions/auth-supports-requests/stats';

  /**
   * Get stats about subscriptions auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionsAuthSupportsRequestStats()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportsRequestStats$Response(params: GetSubscriptionsAuthSupportsRequestStats$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionAuthSupportsRequestStats>>> {
    return getSubscriptionsAuthSupportsRequestStats(this.http, this.rootUrl, params, context);
  }

  /**
   * Get stats about subscriptions auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionsAuthSupportsRequestStats$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSubscriptionsAuthSupportsRequestStats(params: GetSubscriptionsAuthSupportsRequestStats$Params, context?: HttpContext): Observable<Array<SubscriptionAuthSupportsRequestStats>> {
    return this.getSubscriptionsAuthSupportsRequestStats$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SubscriptionAuthSupportsRequestStats>>): Array<SubscriptionAuthSupportsRequestStats> => r.body)
    );
  }

  /** Path part for operation `createSubscriptionAuthSupportsRequest()` */
  static readonly CreateSubscriptionAuthSupportsRequestPath = '/custom/subscriptions/{uid}/auth-supports-requests';

  /**
   * Create a subscription auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscriptionAuthSupportsRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionAuthSupportsRequest$Response(params: CreateSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSubscriptionAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a subscription auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSubscriptionAuthSupportsRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSubscriptionAuthSupportsRequest(params: CreateSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<void> {
    return this.createSubscriptionAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAuthSupportsRequests()` */
  static readonly ListAuthSupportsRequestsPath = '/custom/auth-supports-requests';

  /**
   * Get all Authorization Support Requests, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAuthSupportsRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuthSupportsRequests$Response(params?: ListAuthSupportsRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportsRequestPagedList>> {
    return listAuthSupportsRequests(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all Authorization Support Requests, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAuthSupportsRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuthSupportsRequests(params?: ListAuthSupportsRequests$Params, context?: HttpContext): Observable<AuthSupportsRequestPagedList> {
    return this.listAuthSupportsRequests$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportsRequestPagedList>): AuthSupportsRequestPagedList => r.body)
    );
  }

  /** Path part for operation `createAuthSupportsRequest()` */
  static readonly CreateAuthSupportsRequestPath = '/custom/auth-supports-requests';

  /**
   * Create an auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuthSupportsRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportsRequest$Response(params: CreateAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Create an auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuthSupportsRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportsRequest(params: CreateAuthSupportsRequest$Params, context?: HttpContext): Observable<void> {
    return this.createAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSubscriptionAuthSupportsRequest()` */
  static readonly GetSubscriptionAuthSupportsRequestPath = '/custom/subscriptions/{uid}/auth-supports-requests/{authSupportUid}';

  /**
   * get a auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionAuthSupportsRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionAuthSupportsRequest$Response(params: GetSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportsRequest>> {
    return getSubscriptionAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * get a auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionAuthSupportsRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionAuthSupportsRequest(params: GetSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<AuthSupportsRequest> {
    return this.getSubscriptionAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportsRequest>): AuthSupportsRequest => r.body)
    );
  }

  /** Path part for operation `updateSubscriptionAuthSupportsRequest()` */
  static readonly UpdateSubscriptionAuthSupportsRequestPath = '/custom/subscriptions/{uid}/auth-supports-requests/{authSupportUid}';

  /**
   * Update an auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscriptionAuthSupportsRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionAuthSupportsRequest$Response(params: UpdateSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSubscriptionAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSubscriptionAuthSupportsRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSubscriptionAuthSupportsRequest(params: UpdateSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<void> {
    return this.updateSubscriptionAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSubscriptionAuthSupportsRequest()` */
  static readonly DeleteSubscriptionAuthSupportsRequestPath = '/custom/subscriptions/{uid}/auth-supports-requests/{authSupportUid}';

  /**
   * Delete a subscription auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSubscriptionAuthSupportsRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscriptionAuthSupportsRequest$Response(params: DeleteSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSubscriptionAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a subscription auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSubscriptionAuthSupportsRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSubscriptionAuthSupportsRequest(params: DeleteSubscriptionAuthSupportsRequest$Params, context?: HttpContext): Observable<void> {
    return this.deleteSubscriptionAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAuthSupportsRequest()` */
  static readonly GetAuthSupportsRequestPath = '/custom/auth-supports-requests/{uid}';

  /**
   * get a auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportsRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportsRequest$Response(params: GetAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportsRequest>> {
    return getAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * get a auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportsRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportsRequest(params: GetAuthSupportsRequest$Params, context?: HttpContext): Observable<AuthSupportsRequest> {
    return this.getAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportsRequest>): AuthSupportsRequest => r.body)
    );
  }

  /** Path part for operation `updateAuthSupportsRequest()` */
  static readonly UpdateAuthSupportsRequestPath = '/custom/auth-supports-requests/{uid}';

  /**
   * Update an auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAuthSupportsRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportsRequest$Response(params: UpdateAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Update an auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAuthSupportsRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportsRequest(params: UpdateAuthSupportsRequest$Params, context?: HttpContext): Observable<void> {
    return this.updateAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAuthSupportsRequest()` */
  static readonly DeleteAuthSupportsRequestPath = '/custom/auth-supports-requests/{uid}';

  /**
   * Delete an auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuthSupportsRequest()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportsRequest$Response(params: DeleteAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete an auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuthSupportsRequest$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportsRequest(params: DeleteAuthSupportsRequest$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authSupportsRequestAddComment()` */
  static readonly AuthSupportsRequestAddCommentPath = '/custom/auth-supports-requests/{uid}/comment';

  /**
   * Add comment to an auth supports request.
   *
   * Add a comment to an auth supports request
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authSupportsRequestAddComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authSupportsRequestAddComment$Response(params: AuthSupportsRequestAddComment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return authSupportsRequestAddComment(this.http, this.rootUrl, params, context);
  }

  /**
   * Add comment to an auth supports request.
   *
   * Add a comment to an auth supports request
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authSupportsRequestAddComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authSupportsRequestAddComment(params: AuthSupportsRequestAddComment$Params, context?: HttpContext): Observable<void> {
    return this.authSupportsRequestAddComment$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `downloadAuthSupportsRequestTemplateFile()` */
  static readonly DownloadAuthSupportsRequestTemplateFilePath = '/custom/auth-supports-requests/import/template';

  /**
   * Download a template excel file to be used to create an auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadAuthSupportsRequestTemplateFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadAuthSupportsRequestTemplateFile$Response(params?: DownloadAuthSupportsRequestTemplateFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return downloadAuthSupportsRequestTemplateFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Download a template excel file to be used to create an auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadAuthSupportsRequestTemplateFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadAuthSupportsRequestTemplateFile(params?: DownloadAuthSupportsRequestTemplateFile$Params, context?: HttpContext): Observable<Blob> {
    return this.downloadAuthSupportsRequestTemplateFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `uploadAuthSupportsRequestFile()` */
  static readonly UploadAuthSupportsRequestFilePath = '/custom/auth-supports-requests/import/{subscriptionUid}';

  /**
   * Upload an excel file to be used to create an auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadAuthSupportsRequestFile()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  uploadAuthSupportsRequestFile$Response(params: UploadAuthSupportsRequestFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return uploadAuthSupportsRequestFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload an excel file to be used to create an auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadAuthSupportsRequestFile$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  uploadAuthSupportsRequestFile(params: UploadAuthSupportsRequestFile$Params, context?: HttpContext): Observable<void> {
    return this.uploadAuthSupportsRequestFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changeAuthSupportsRequestState()` */
  static readonly ChangeAuthSupportsRequestStatePath = '/custom/auth-supports-requests/{uid}/state';

  /**
   * Change the state of an auth supports request.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeAuthSupportsRequestState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAuthSupportsRequestState$Response(params: ChangeAuthSupportsRequestState$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeAuthSupportsRequestState(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the state of an auth supports request.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeAuthSupportsRequestState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAuthSupportsRequestState(params: ChangeAuthSupportsRequestState$Params, context?: HttpContext): Observable<void> {
    return this.changeAuthSupportsRequestState$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `generateAuthSupportsRequest()` */
  static readonly GenerateAuthSupportsRequestPath = '/custom/auth-supports-requests/{uid}/generate';

  /**
   * request to genenerate auth supports request document.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateAuthSupportsRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateAuthSupportsRequest$Response(params: GenerateAuthSupportsRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<FileDownloadResponse>> {
    return generateAuthSupportsRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * request to genenerate auth supports request document.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `generateAuthSupportsRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateAuthSupportsRequest(params: GenerateAuthSupportsRequest$Params, context?: HttpContext): Observable<FileDownloadResponse> {
    return this.generateAuthSupportsRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<FileDownloadResponse>): FileDownloadResponse => r.body)
    );
  }

}
